import { combineReducers } from "redux";
import jobsReducer from "../../features/jobs/jobsReducer";
import modalReducer from "../common/modals/modalReducer";
import mapReducer from "../../features/map/mapReducer";
import asyncReducer from "../async/asyncReducer";
import authReducer from "../../features/auth/authReducer";
import accountReducer from "../../features/account/accountReducer";
import { connectRouter } from "connected-react-router";
import employerReducer from "../../features/employer/employerReducer";
import adminReducer from "../../features/admin/adminReducer";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import navigationReducer from "./navigationReducer";
import jobSeekerReducer from "../../features/jobSeeker/jobSeekerReducer";
import appReducer from "./appReducer";
import promotionsReducer from "../../features/promotions/promotionsReducer";
import companiesReducer from "../../features/companies/companiesReducer";
import candidatesReducer from "../../features/candidates/candidatesReducer";

const persistConfig = {
  key: "root",
  storage,
};

const rootReducer = (history) =>
  combineReducers({
    account: accountReducer,
    admin: adminReducer,
    app: appReducer,
    async: asyncReducer,
    auth: persistReducer(persistConfig, authReducer),
    candidates: candidatesReducer,
    companies: companiesReducer,
    employer: employerReducer,
    jobSeeker: jobSeekerReducer,
    jobs: jobsReducer,
    map: mapReducer,
    modals: modalReducer,
    navigation: navigationReducer,
    promotions: promotionsReducer,
    router: connectRouter(history),
  });

export default rootReducer;
